module.exports = __webpack_public_path__ + "img/PAYATPOST.84c9724.png";